import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgxsModule } from '@ngxs/store';

import { TranslateModule } from '@ngx-translate/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';

import { CriterionAdditionSharedModule } from '@app/criterion-addition/shared/criterion-addition-shared.module';
import { DestinationAdGroupsComponent } from '@app/criterion-addition/shared/modules/destination-match-type/components/destination-ad-groups/destination-ad-groups.component';
import { DestinationsComponent } from '@app/criterion-addition/shared/modules/destination-match-type/components/destinations/destinations.component';
import { MatchTypesComponent } from '@app/criterion-addition/shared/modules/destination-match-type/components/match-types/match-types.component';
import { DestinationMatchTypeComponent } from '@app/criterion-addition/shared/modules/destination-match-type/destination-match-type.component';
import { DestinationMatchTypeState } from '@app/criterion-addition/shared/modules/destination-match-type/state/destination-match-type.state';
import { CriterionAdditionSuggestionsTableModule } from '@app/criterion-addition/shared/modules/suggestions-table/suggestions-table.module';
import { AdGroupLabelComponent } from '@app/shared/components/campaign-adgroup-label/ad-group-label.component';
import { CampaignLabelComponent } from '@app/shared/components/campaign-adgroup-label/campaign-label.component';
import { RatioTagComponent } from '@app/shared/components/ratio-tag/ratio-tag.component';
import { AccordionModule } from '@app/shared/modules/accordion/accordion.module';
import { AdvancedFilterModule } from '@app/shared/modules/advanced-filter/advanced-filter.module';
import { EqualSizeModule } from '@app/shared/modules/equal-size/equal-size.module';
import { NoticeViewModule } from '@app/shared/modules/notice-view/notice-view.module';

import { SpinnerOverlayComponent } from '@app/shared/modules/spinner-overlay/spinner-overlay.component';
import { TourModule } from '@app/shared/modules/tour/tour.module';
import { SharedDirectivesModule } from '@app/shared/shared-directives.module';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    TranslateModule,
    NgxsModule.forFeature([DestinationMatchTypeState]),

    NzCheckboxModule,
    NzButtonModule,
    NzInputModule,
    NzSelectModule,

    AccordionModule,
    CriterionAdditionSharedModule,
    AdvancedFilterModule,
    SharedDirectivesModule,
    SpinnerOverlayComponent,
    NzTagModule,
    EqualSizeModule,
    NzToolTipModule,
    NzRadioModule,
    NoticeViewModule,
    TourModule,
    CriterionAdditionSuggestionsTableModule,
    RatioTagComponent,
    AdGroupLabelComponent,
    CampaignLabelComponent,
  ],
  declarations: [
    DestinationMatchTypeComponent,
    DestinationsComponent,
    MatchTypesComponent,
    DestinationAdGroupsComponent,
  ],
  exports: [DestinationMatchTypeComponent, DestinationAdGroupsComponent],
})
export class DestinationMatchTypeModule {}
